import instance from "./BaseApi";

export function attemptGetOrgUsers() {
  return instance.request({
    url: `organisations/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptInviteOrg(data) {
  return instance.request({
    url: `organisation/${data?.organisation}/invite/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
}

export function attemptGetOrgDetails(id) {
  return instance.request({
    url: `organisations/${id}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptDeleteOrg(id) {
  return instance.request({
    url: `organisations/${id}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptCreateOrg(data) {
  return instance.request({
    url: `organisations/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptUpdateOrg(parmas) {
  const data = {
    name: parmas?.name,
    email: parmas?.email,
    type: parmas?.type,
    status: parmas?.status,
  };
  return instance.request({
    url: `organisations/${parmas?.id}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptGetOrganisationDetails(orgID) {
  return instance.request({
    url: `organisations/${orgID}/details/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptCreateOrganisationDetails(orgID, data) {
  return instance.request({
    url: `organisations/${orgID}/details/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attempUpdateOrganisationDetails(orgID, data) {
  return instance.request({
    url: `organisations/${orgID}/details/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptGetOrgLocations(id) {
  return instance.request({
    url: `organisations/${id}/locations/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptGetOrgLocationsByUser(userId) {
  return instance.request({
    url: `user/${userId}/organisation/locations/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptGetOrgLocationsMetrics(data, metricType) {
  return instance.request({
    url: `dashboard/connection-metrics/${metricType}/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptGetLiveConnectionStats(data) {
  return instance.request({
    url: `dashboard/live-connection-metrics/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptGetLocations(id) {
  return instance.request({
    url: `locations/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptCreateOrgLocations(data) {
  return instance.request({
    url: `locations/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptDeleteOrgLocations(data) {
  return instance.request({
    url: `locations/${data.id}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptEditOrgLocations(data) {
  const editData = {
    name: data.name,
    address: data.address,
    location_type: data.location_type,
    brand_id: data.brand_id,
    timezone: data.timezone,
  };

  return instance.request({
    url: `locations/${data.id}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: editData,
  });
}

export function attemptOrgUsers(id) {
  return instance.request({
    url: `users/organisation/${id}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptEditOrgUser(owner_id, data) {
  return instance.request({
    url: `users/organisation/${owner_id}/update/`,
    method: "PUT",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptDeleteOrgUser(owner_id, data) {
  return instance.request({
    url: `users/organisation/${owner_id}/delete/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptGetLiveAccessPointsStatus(data) {
  return instance.request({
    url: `guest-wifi-settings/access-points/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptGetWirelessLAN(orgID) {
  return instance.request({
    url: `guest-wifi-settings/networks/organisation/${orgID}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptUpdateWirelessLAN(orgID, data) {
  return instance.request({
    url: `guest-wifi-settings/networks/organisation/${orgID}`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptGetGuestPortalSettings(orgID) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/organisation/${orgID}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptUpdateGuestPortalSettings(orgID, data) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/organisation/${orgID}`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}

export function attemptGetGuestPortalSettingsBanner(guestPortalID) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/${guestPortalID}/banner/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptCreateGuestPortalSettingsBanner(guestPortalID, data, brandId = null, planId = null) {
  let url = `guest-wifi-settings/guest-portal/${guestPortalID}/banner/`;

  // Build query parameters properly
  const params = [];
  if (brandId) params.push(`brandId=${brandId}`);
  if (planId) params.push(`planId=${planId}`);
  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return instance.request({
    url: url,
    method: "POST",
    withCredentials: false,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}

export function attemptUpdateGuestPortalSettingsBanner(guestPortalID, data, brandId = null, planId = null) {
  let url = `guest-wifi-settings/guest-portal/${guestPortalID}/banner/`;

  // Build query parameters properly
  const params = [];
  if (brandId) params.push(`brandId=${brandId}`);
  if (planId) params.push(`planId=${planId}`);
  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return instance.request({
    url: url,
    method: "PATCH",
    withCredentials: false,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}

export function attemptGetGuestPortalSettingsLinks(guestPortalID) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/${guestPortalID}/links/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptCreateGuestPortalSettingsLinks(guestPortalID, data, brandId = null, planId = null) {
  let url = `guest-wifi-settings/guest-portal/${guestPortalID}/links/`;

  // Build query parameters properly
  const params = [];
  if (brandId) params.push(`brandId=${brandId}`);
  if (planId) params.push(`planId=${planId}`);
  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return instance.request({
    url: url,
    method: "POST",
    withCredentials: false,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}

export function attemptUpdateGuestPortalSettingsLinks(guestPortalID, data, brandId = null, planId = null) {
  let url = `guest-wifi-settings/guest-portal/${guestPortalID}/links/`;

  // Build query parameters properly
  const params = [];
  if (brandId) params.push(`brandId=${brandId}`);
  if (planId) params.push(`planId=${planId}`);
  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return instance.request({
    url: url,
    method: "PATCH",
    withCredentials: false,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}

export function attemptDeleteGuestPortalSettingsLinks(guestPortalID, linkID, brandId = null, planId = null) {
  let url = `guest-wifi-settings/guest-portal/${guestPortalID}/links/`;

  // Build query parameters properly
  const params = [];
  if (brandId) params.push(`brandId=${brandId}`);
  if (planId) params.push(`planId=${planId}`);
  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return instance.request({
    url: url,
    method: "DELETE",
    withCredentials: false,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: {
      id: linkID,
    },
  });
}

export function attemptGetZones(data) {
  return instance.request({
    url: "zones/list/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {
      location_ids: data,
    },
  });
}

export function attemptCreateBrand(orgID, data) {
  return instance.request({
    url: `brands/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {
      ...data,
      organisation_id: orgID,
    },
  });
}

export function attemptGetSpecificBrand(brandId) {
  return instance.request({
    url: `brands/${brandId}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptGetAllBrands(orgID) {
  return instance.request({
    url: `organisation/${orgID}/brands/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptUpdateBrand(brandId, data) {
  return instance.request({
    url: `brands/${brandId}/`,
    method: "PUT",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptDeleteBrand(brandId) {
  return instance.request({
    url: `brands/${brandId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// NEW: Location-based guest portal settings GET
export function attemptGetLocationGuestPortalSettings(locationId, planId = null) {
  let url = `guest-wifi-settings/guest-portal/location/${locationId}/`;
  // If planId is provided, append it to the URL
  if (planId) {
    url += `?planId=${planId}`;
  }
  return instance.request({
    url: url,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// NEW: Location-based guest portal settings UPDATE with optional brand support
export function attemptUpdateLocationGuestPortalSettings(locationId, data, brandId = null, planId = null) {
  let url = `guest-wifi-settings/guest-portal/location/${locationId}/`;
  const params = [];
  if (brandId) params.push(`brandId=${brandId}`);
  if (planId) params.push(`planId=${planId}`);
  if (params.length) url += `?${params.join("&")}`;
  return instance.request({
    url: url,
    method: "PATCH",
    withCredentials: false,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}

// NEW: Brand-based guest portal settings GET
export function attemptGetBrandGuestPortalSettings(brandId, planId = null) {
  // If planId is provided, append it to the URL
  let url = `guest-wifi-settings/guest-portal/brand/${brandId}/`;
  if (planId) {
    url += `?planId=${planId}`;
  }
  return instance.request({
    url: url,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// NEW: Brand-based guest portal settings UPDATE with optional brand support
export function attemptUpdateBrandGuestPortalSettings(data, brandId, planId = null) {
  let url = `guest-wifi-settings/guest-portal/brand/${brandId}/`;
  // If planId is provided, append it to the URL
  if (planId) {
    url += `?planId=${planId}`;
  }
  return instance.request({
    url: url,
    method: "PATCH",
    withCredentials: false,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}

// Endpoint to get plans for guest portal settings
export function attemptGetPlansGuestPortalSettings(brandId, locationId = null) {
  let url = `guest-wifi-settings/guest-portal/plans/`;
  if (brandId) {
    url += `?brandId=${brandId}`;
  } else if (locationId) {
    url += `?locationId=${locationId}`;
  }
  return instance.request({
    url: url,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// Endpoint to create guest portal settings plan
export function attemptCreatePlanGuestPortalSettings(data) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/plans/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

// Endpoint to update guest portal settings plan
export function attemptUpdatePlanGuestPortalSettings(planId, data) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/plans/${planId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

// Endpoint to delete guest portal settings plan
export function attemptDeletePlanGuestPortalSettings(planId, brandId = null, locationId = null) {
  let url = `guest-wifi-settings/guest-portal/plans/${planId}/`;
  
  // Build query parameters if needed
  const params = [];
  if (brandId) params.push(`brandId=${brandId}`);
  if (locationId) params.push(`locationId=${locationId}`);
  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }
  
  return instance.request({
    url: url,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    }
  });
}

export function attemptGetActiveLocationGuestPortalSettings(locationId) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/active/${locationId}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptGetGuestPortalSettingsById(guestPortalId) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/${guestPortalId}/full/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// Guest portal periods API functions
export function attemptGetGuestPortalPeriods(planId) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/plans/${planId}/periods/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptCreateGuestPortalPeriod(planId, data) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/plans/${planId}/periods/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptUpdateGuestPortalPeriod(periodId, data) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/periods/${periodId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function attemptDeleteGuestPortalPeriod(periodId) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/periods/${periodId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptGetPeriodGuestPortalSettings(settingId) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/${settingId}/full/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function attemptUpdatePeriodGuestPortalSettings(periodId, data) {
  return instance.request({
    url: `guest-wifi-settings/guest-portal/period/${periodId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}
